/**
 * Strip the machine payload off a Watcher alert message before it reaches a reader.
 *
 * 🚨 THE DEFECT THIS EXISTS TO STOP, measured live on /stocks/HTZ 2026-08-23. The page rendered:
 *
 *   The Watcher SOLD $HTZ at $2.2400 __THOTH_JSON__{"side":"sell","strategyLabel":"The Watcher · day",
 *   "reason":"time_box","shares":2,"instance":"Rider"}
 *
 * as VISIBLE BODY TEXT, 14 times on one page. Alert messages carry a `__THOTH_JSON__` sentinel with a
 * structured payload after it, meant to be parsed for the trade card and stripped from the prose.
 * SymbolTape did that. StockActivityStream and PulseBoard did not, and /stocks/[symbol] renders
 * StockActivityStream.
 *
 * ⚠ WHAT IT EXPOSED IS WORSE THAN UNTIDY: internal field names, share counts, setup ids
 * ("breakout-coil", "burst-revbreak", "support-reclaim") and `"instance":"Rider"` - the name of a
 * persona RETIRED on 2026-07-25. On a finance site that reads as a broken product, not a style slip.
 *
 * ⭐ SO IT LIVES IN ONE PLACE NOW. Three components rendered the same field and one of them handled
 * it; that is the same shape as the /compare canonical fixed in one of three places and the FAQPage
 * duplicate fixed four times in four days. A helper cannot drift from itself.
 */

export const THOTH_SENTINEL = '__THOTH_JSON__'

export type ThothTradeMeta = {
  strategyLabel?: string; setup?: string
  side?: string; entryPrice?: number; exitPrice?: number; shares?: number
  realizedPlPct?: number; reason?: string; instance?: string
}

/** The human half of an alert message. Safe on null, undefined and messages with no sentinel. */
export function cleanAlertMessage(msg: string | null | undefined): string {
  return String(msg ?? '').split(THOTH_SENTINEL)[0].trim()
}

/** The machine half, or null when absent or malformed. Never throws. */
export function parseThothMeta(msg: string | null | undefined): ThothTradeMeta | null {
  const raw = String(msg ?? '')
  const i = raw.indexOf(THOTH_SENTINEL)
  if (i < 0) return null
  try { return JSON.parse(raw.slice(i + THOTH_SENTINEL.length)) as ThothTradeMeta } catch { return null }
}
